"use strict";
/* eslint-disable react/prop-types */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortIndicator = void 0;
const react_1 = __importDefault(require("react"));
const SortIndicator = ({ currentSort, accessor }) => {
    const iStyle = {
        paddingLeft: '5px',
    };
    if (currentSort && currentSort.key === accessor) {
        if (currentSort && currentSort.desc) {
            return react_1.default.createElement("i", { className: 'fa fa-chevron-up', style: iStyle });
        }
        return react_1.default.createElement("i", { className: 'fa fa-chevron-down', style: iStyle });
    }
    return react_1.default.createElement("i", { className: 'fa fa-sort', style: iStyle });
};
exports.SortIndicator = SortIndicator;
